import { useQuery } from "@tanstack/react-query"
import { RoleRequestGet } from "../app/models/RoleRequest"
import { digitalManagerApi } from "../services/api"

export function useRoleRequests(getCompleted = false) {
  const { data: roleRequestsList = [], isLoading: isLoadingRoleRequests } = useQuery({
    queryKey: ["roleRequests", getCompleted],
    queryFn: () =>
      digitalManagerApi
        .get<RoleRequestGet[]>("/roleRequests", { params: { completed: getCompleted } })
        .then((r) => r.data),
  })

  return {
    roleRequestsList,
    isLoadingRoleRequests,
  }
}
